const EXPO_SITE = 'https://www.brazoscountyexpo.com?from=fair';
const SPLASH_KEY = 'splash';

const THEMES = {
  fair: {
    img: 'images/splash_assets/fair-logo.png',
    alt: 'Fair Logo',
  },
  expo: {
    img: 'images/splash_assets/expo-logo.png',
    alt: 'Brazos County Expo',
  },
};

function getTemplate() {
  return `
    <div id="splashPage" aria-modal="true" role="dialog">
      <div class="splash-module fairTheme">
        <div class="inner-container">
          <img class="splash-logo" src="${FULLCLIENTTHEMEPATH}${THEMES.fair.img}" alt="${THEMES.fair.alt}">
          <a class="button current-site" role="button" tabindex="0">Enter Site</a>
        </div>
      </div>
      <div class="splash-module expoTheme">
        <div class="inner-container">
          <img class="splash-logo" src="${FULLCLIENTTHEMEPATH}${THEMES.expo.img}" alt="${THEMES.expo.alt}">
          <a class="button external-site" href="${EXPO_SITE}" aria-label="Go to ${THEMES.expo.alt} site">Enter Site</a>
        </div>
      </div>
    </div>
  `;
}

function isHomepage() {
  return $('body').hasClass('homepage');
}

function setSplashCookie() {
  Cookies.set(SPLASH_KEY, 'true');
}

function shouldSkipSplash() {
  const params = new URLSearchParams(globalThis.location.search);
  const isFromExpo = params.get('from') === 'expo';

  if (isFromExpo) {
    Cookies.set(SPLASH_KEY, 'true');

    globalThis.history.replaceState(
      {},
      document.title,
      globalThis.location.pathname + globalThis.location.hash,
    );

    return true;
  }

  return Cookies.get(SPLASH_KEY) === 'true';
}

function destroySplash() {
  const $splashPage = $('#splashPage');
  const $body = $('body:not([ng-app="SaffireAngularApp"])');

  $splashPage.css('opacity', 0);
  $body.removeClass('splashPage');

  setTimeout(function () {
    $splashPage.remove();
  }, 1000);
}

function createSplashPage() {
  const $body = $('body:not([ng-app="SaffireAngularApp"])');
  $body.addClass('splashPage');

  const $template = $(getTemplate());
  $('body').prepend($template);

  $template.on('click', '.current-site', function (e) {
    e.preventDefault();
    setSplashCookie();
    destroySplash();
  });

  $template.on('click', '.external-site', function () {
    setSplashCookie();
  });

  $template.on('keydown', '.current-site, .external-site', function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      if (e.key === ' ') {
        e.preventDefault();
      }
      this.click();
    }
  });

  setupFocusTrap($template);
}

function setupFocusTrap($container) {
  const $focusable = $container.find('a, button, [tabindex="0"]');
  const $first = $focusable.first();
  const $last = $focusable.last();

  setTimeout(function () {
    $first.focus();
  }, 100);

  $container.on('keydown', function (e) {
    if (e.key !== 'Tab') {
      return;
    }

    if (e.shiftKey) {
      if (document.activeElement === $first[0]) {
        e.preventDefault();
        $last.focus();
      }
    } else if (document.activeElement === $last[0]) {
      e.preventDefault();
      $first.focus();
    }
  });
}

export default function splashPageFeature(isEnabled) {
  if (isEnabled !== true) return;

  if (!isHomepage()) {
    if (!Cookies.get(SPLASH_KEY)) {
      setSplashCookie();
    }
    return;
  }

  if (!shouldSkipSplash()) {
    createSplashPage();
  }
}
